export default "__VITE_ASSET__CExEvkaD__"